module.exports = __webpack_public_path__ + "static/Button_for_connecting_Planday-21bf437ba1a805554a48b1195e498305.jpg";